import { AxiosError } from 'axios';
import { TFunction } from 'i18next';

export function createFieldValidationErrorObject(error?: AxiosError, t?: TFunction): Record<string, string | string[]> {
  if (error?.response?.status !== 422) {
    return {};
  }

  const errors = error?.response?.data?.detail || {};

  if (t) {
    const translate = (msg: string) => {
      const translated = t(`backendValidationMap.${msg}`);
      return translated === `backendValidationMap.${msg}` ? msg : translated;
    };

    Object.entries(errors).forEach(([field, message]) => {
      errors[field] = Array.isArray(message) ? message.map(translate) : translate(message as string);
    });
  }

  return errors;
}

export const createFieldArrayErrors = ({ error, errorType, errorText, setError, fieldArrayName, fieldName, t }) => {
  if (error?.response?.status !== 422) {
    return {};
  }

  const errors = error?.response?.data?.detail || {};

  const filteredErrors = errors.filter((detail) => detail.type === errorType);

  filteredErrors.forEach((error) => {
    const fieldIndex = error.loc[2];
    setError(`${fieldArrayName}.${fieldIndex}.${fieldName}`, {
      message: t(errorText),
    });
  });
};
